export const nosPrestations = {
    prestations: [
        {
          id: 1,
          name: "Clôtures & portails",
          desc: "Pose de <b>tous types de clôtures et portails</b> pour les industries, les collectivités et les particuliers. <b class='text-primary'>Emery Paysages</b> vous propose <b>portails coulissants, autoportants " +
                "et battants</b> en Aluminium, PVC ou bois avec toutes sortes de piliers (Aluminium, pierre, brique…).",
          items: [
            "cp/1.jpg",
            "cp/2.jpg",
            "cp/3.jpg",
            "cp/4.jpg",
            "cp/5.jpg",
            "cp/6.jpg"
          ]
        },
        {
          id: 2,
          name: "Entretien de vos espaces verts",
          desc: "<b class='text-primary'>Emery Paysages</b> effectue l'entretien de <b>petits comme de grands jardins</b>, l'entretien de collectivités, particuliers, entreprises et résidences secondaires. " +
                "Prestations sous forme de contrats annuels ou ponctuels : <b>tonte de pelouses, broyage d'herbe, débroussaillage, taille de haies</b>… En tant que particulier, vous pouvez bénéficier d’un <b>abattement fiscal de 50%</b>*." +
                "<p class='small font-italic mb-0'>* à hauteur de 5000€ de prestation par an par foyer fiscal** soit 2500€ de réduction/crédit d’impôt au maximum.</p>" +
                "<p class='small font-italic mb-0'>** selon l’article 199 sexdecies du code général des impôts.</p>" +
                "<img class='sap-logo' src='"+require('../assets/img/sap-logo.png')+"' alt='Emery Paysages SAP Logo' />",
          items: [
            "eev/1.jpg",
            "eev/2.jpg",
            "eev/3.jpg",
            "eev/4.jpg",
            "eev/5.jpg",
            "eev/6.jpg"
          ]
        },
        {
          id: 3,
          name: "Élagage & abattage / Rognage de souches",
          desc: "<b class='text-primary'>Emery Paysages</b> réalise vos <b>travaux d'élagage et d'abattage de toutes hauteurs sur des arbres</b> aussi bien simples que délicats ou dangereux (maison, bâtiment ou terrasse à proximité) avec " +
                "l'aide de notre matériel parfaitement adapté pour ce type de chantiers. Après l’abattage d’un arbre, il peut rester une souche disgracieuse au milieu de votre gazon. <b class='text-primary'>Emery Paysages</b> " +
                "propose donc un <b>service de rognage de souches</b>.",
          items: [
            "ear/1.jpg",
            "ear/2.jpg",
            "ear/3.jpg",
            "ear/4.jpg",
            "ear/5.jpg",
            "ear/6.jpg"
          ]
        },
        {
          id: 4,
          name: "Aménagements extérieurs",
          desc: "Réalisations <b>de bassins, de massifs d’arbustes, la plantation de haies et d’arbres</b> ou encore l'aménagement de votre terrasse. <b class='text-primary'>Emery Paysages</b> et son équipe de paysagistes " +
                "saura vous conseiller au mieux pour <b>embellir votre jardin</b>.",
          items: [
            "tbp/1.jpg",
            "tbp/2.jpg",
            "tbp/3.jpg",
            "tbp/4.jpg",
            "tbp/5.jpg",
            "tbp/6.jpg"
          ]
        },
        {
          id: 5,
          name: "Allées & bordures",
          desc: "Vous souhaitez faire ou refaire l'<b>accès à votre garage ou à votre maison</b> ? Réaliser une <b>allée piétonne</b> ? Délimiter votre chemin avec une bordure ? <b class='text-primary'>Emery Paysages</b> vous propose <b>différents " +
                "matériaux qui s'accorderont avec le style de votre maison</b>. Des dalles alvéolées, toutes sortes de graviers décoratifs, revêtement en émulsions ou béton désactivé, pavés de rue, pavés en grès…",
          items: [
            "aab/1.jpg",
            "aab/2.jpg",
            "aab/3.jpg",
            "aab/4.jpg",
            "aab/5.jpg",
            "aab/6.jpg"
          ]
        }
    ],
}

export default [
    nosPrestations,
]